import { render, staticRenderFns } from "./RegisterLinkPopup.vue?vue&type=template&id=3e395637&scoped=true"
import script from "./RegisterLinkPopup.vue?vue&type=script&lang=js"
export * from "./RegisterLinkPopup.vue?vue&type=script&lang=js"
import style0 from "./RegisterLinkPopup.vue?vue&type=style&index=0&id=3e395637&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e395637",
  null
  
)

export default component.exports